import { PrivateAxiosInstance } from "config/axios";
const getAuthToken = () => {
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  return userData?.token;
};

export const API_GET_DASHBOARED = async (params) => {
    try {
      const authToken = getAuthToken(); // Get token each time before making an API request
  
      const response = await PrivateAxiosInstance.get(
        "/dashboard/get-dashboard",
        {
          headers: {
            Authorization: `${authToken}`, // Add the Authorization header with the token
          },
          params: params, // Include dynamic params
        }
      );
      return response.data; // You may want to return the response data to handle it in your components
    } catch (error) {
      throw error; // Rethrow the error for handling in your components
    }
  };
  